export default "__VITE_ASSET__DiGQ94fJ__"